import React from 'react';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import AddIcon from '@material-ui/icons/Add';
import AlbumIcon from '@material-ui/icons/Album';
import AirplayIcon from '@material-ui/icons/Airplay';
import ArchiveIcon from '@material-ui/icons/Archive';
import BackspaceIcon from '@material-ui/icons/Backspace';
import CancelIcon from '@material-ui/icons/Cancel';
import ChevronDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ChevronLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import ChevronRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ChevronUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CloseIcon from '@material-ui/icons/Close';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import EditIcon from '@material-ui/icons/Edit';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Filter1Icon from '@material-ui/icons/Filter1';
import Filter2Icon from '@material-ui/icons/Filter2';
import FolderIcon from '@material-ui/icons/Folder';
import GetAppIcon from '@material-ui/icons/GetApp';
import HistoryIcon from '@material-ui/icons/History';
import InfoIcon from '@material-ui/icons/Info';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';
import ListIcon from '@material-ui/icons/List';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import PauseIcon from '@material-ui/icons/Pause';
import PersonIcon from '@material-ui/icons/Person';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PlayIcon from '@material-ui/icons/PlayArrow';
import RefreshIcon from '@material-ui/icons/Refresh';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import SaveIcon from '@material-ui/icons/Save';
import SettingsIcon from '@material-ui/icons/Settings';
import ShareIcon from '@material-ui/icons/Share';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import VolumeDownIcon from '@material-ui/icons/VolumeDown';
import VolumeMuteIcon from '@material-ui/icons/VolumeMute';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import StorefrontIcon from '@material-ui/icons/Storefront';

import Styled from './styled';
import Spinner from '../Spinner';
import Tooltip from '../Tooltip';

const icons = {
  access_alarm_icon: AccessAlarmIcon,
  add: AddIcon,
  add_to_worklist: CreateNewFolderIcon,
  add_to_worklist_1: CreateNewFolderIcon,
  add_to_worklist_2: CreateNewFolderIcon,
  archive: ArchiveIcon,
  ask: ContactSupportIcon,
  cancel: CancelIcon,
  chevron_down: ChevronDownIcon,
  chevron_left: ChevronLeftIcon,
  chevron_right: ChevronRightIcon,
  chevron_up: ChevronUpIcon,
  close: CloseIcon,
  contact_support: ContactSupportIcon,
  delete: DeleteIcon,
  delete_sweep: DeleteSweepIcon,
  download: GetAppIcon,
  edit: EditIcon,
  expand_less: ChevronUpIcon,
  expand_more: ChevronDownIcon,
  featured: StarBorderIcon,
  filter_1: Filter1Icon,
  filter_2: Filter2Icon,
  help: ContactSupportIcon,
  history: HistoryIcon,
  info: InfoIcon,
  list: ListIcon,
  lock: LockIcon,
  lock_open: LockOpenIcon,
  logout: ExitToAppIcon,
  news: NewReleasesIcon,
  pause: PauseIcon,
  person: PersonIcon,
  account: AccountCircleIcon,
  play: PlayIcon,
  plus: AddIcon,
  question: ContactSupportIcon,
  refresh: RefreshIcon,
  remove_shopping_cart: RemoveShoppingCartIcon,
  reset_filter: BackspaceIcon,
  save: SaveIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  shopping_cart: ShoppingCartIcon,
  skip_next: SkipNextIcon,
  skip_previous: SkipPreviousIcon,
  smartlist: LibraryMusicIcon,
  support: AlbumIcon,
  track: MusicNoteIcon,
  trash: DeleteIcon,
  usage: AirplayIcon,
  video_library: VideoLibraryIcon,
  volume_down: VolumeDownIcon,
  volume_mute: VolumeMuteIcon,
  volume_off: VolumeOffIcon,
  volume_up: VolumeUpIcon,
  worklist: FolderIcon,
  worklist_1: FolderIcon,
  worklist_2: FolderIcon,
  store: StorefrontIcon,
};

type Props = {
  className?: any,
  disabled?: boolean,
  loading?: boolean,
  name: $Keys<typeof icons>,
  size?: 'default' | 'inherit' | 'large' | 'small',
  style?: any,
  tooltip?: string,
};

export default ({
  className,
  disabled = false,
  loading = false,
  name,
  size = 'small',
  style,
  tooltip,
}: Props): React$Element<any> => {
  if (loading) {
    return <Spinner />;
  }
  const IconComponent = icons[name];
  if (IconComponent == null) {
    return null;
  }
  let overlayText;
  let overlayTextStyle = {};
  const overlayTextWorklistStyle = {
    fontSize: '11px',
    fontWeight: 'bold',
    top: '33%',
    left: '33%',
  };
  const overlayTextWorklistWithNumberStyle = {
    fontSize: '10px',
    top: '33%',
    left: '29%',
  };
  const overlayTextUsageStyle = {
    fontSize: '9px',
    top: '26%',
    left: '26%',
  };
  switch (name) {
    case 'worklist':
      overlayText = 'W';
      overlayTextStyle = overlayTextWorklistStyle;
      break;
    case 'worklist_1':
      overlayText = 'W1';
      overlayTextStyle = overlayTextWorklistWithNumberStyle;
      break;
    case 'worklist_2':
      overlayText = 'W2';
      overlayTextStyle = overlayTextWorklistWithNumberStyle;
      break;
    case 'add_to_worklist':
      overlayText = 'W';
      break;
    case 'add_to_worklist_1':
      overlayText = 'W1';
      break;
    case 'add_to_worklist_2':
      overlayText = 'W2';
      break;
    case 'usage':
      overlayText = 'U';
      overlayTextStyle = overlayTextUsageStyle;
      break;
    default:
      break;
  }
  const renderOverlayText = (text: string) => (
    <Styled.IconTextOverlay style={overlayTextStyle}>{text}</Styled.IconTextOverlay>
  );
  const renderIcon = () => (
    <Styled.IconContainer>
      <IconComponent
        className={className}
        fontSize={size}
        style={Object.assign({ opacity: disabled ? 0.4 : 1 }, style)}
      />
      {overlayText && renderOverlayText(overlayText)}
    </Styled.IconContainer>
  );
  return tooltip ? <Tooltip title={tooltip}>{renderIcon()}</Tooltip> : renderIcon();
};
